import { Typography } from 'antd'
import React from 'react'
import { Candidate } from '../candidate'

export function CandidateCompatibility({ candidate }: { candidate: Candidate }) {
    if (candidate.compatibility === null) {
        return null
    }

    return (
        <Typography.Text className="text-xs">
            {candidate.compatibility >= 70 && <>🏆</>} {candidate.compatibility}%
        </Typography.Text>
    )
}
